function getInitialLapSelection(report) {
  const traces = Array.isArray(report?.traces) ? report.traces : []
  const available = traces
    .map(trace => Number(trace?.lapNumber))
    .filter((lapNumber, index, laps) => Number.isFinite(lapNumber) && laps.indexOf(lapNumber) === index)

  if (!available.length) return { focusLap: null, referenceLap: null }

  const timed = (Array.isArray(report?.laps) ? report.laps : [])
    .map(lap => ({ lapNumber: Number(lap?.lapNumber), lapTimeSeconds: Number(lap?.lapTimeSeconds) }))
    .filter(lap => available.includes(lap.lapNumber) && Number.isFinite(lap.lapTimeSeconds) && lap.lapTimeSeconds > 0)
    .sort((a, b) => a.lapTimeSeconds - b.lapTimeSeconds || a.lapNumber - b.lapNumber)

  const reportedBest = Number(report?.summary?.bestLapNumber)
  const focusLap = available.includes(reportedBest)
    ? reportedBest
    : timed[0]?.lapNumber ?? available[0]
  const referenceLap = timed.find(lap => lap.lapNumber !== focusLap)?.lapNumber
    ?? available.find(lapNumber => lapNumber !== focusLap)
    ?? focusLap

  return { focusLap, referenceLap }
}

module.exports = { getInitialLapSelection }
